<template lang="pug">
.pie__wrapper
  .pie__loader(v-if="loading")
    q-spinner(color="primary", size="3em")
  pie-chart(v-else, :chartData="chartData", :wrapLegend="pieWrap")
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { backend } from "@/api";
import { useEmitter } from "@/services/useEmitter";
import { generateFiltersParams } from "@/services/generateFiltersParams";
import { useStore } from "@/store";
import { handleError } from "@/services/handleErrors";
import pieChart from "../../../shared/charts/pie/pieChart";

const emitter = useEmitter();

const store = useStore();

const props = defineProps({
  type: { type: String, required: true },
});

const chartData = ref();
const hasZeroValues = ref();
const loading = ref(true);

const pieWrap = ref(false);

const generateParams = () => {
  let localQuery = "";
  let localFilters = {};

  let localGrid = store.state.grid["expensesDashboard"];

  if (localGrid) {
    localQuery = localGrid.query || "";
    localFilters = localGrid.filters ? generateFiltersParams(localGrid.filters) : {};
  }

  const params = {
    query: localQuery,
    filters: localFilters,
    type: props.type,
  };

  return params;
};

const getData = async () => {
  try {
    loading.value = true;
    const params = generateParams();
    const { data } = await backend.index("api/v3/expenses_dashboard/charts", { params }, { encodeNestedData: true });
    chartData.value = data;
  } catch (e) {
    handleError(e);
  } finally {
    loading.value = false;
  }
};

const setPieWrap = () => {
  // 1590 размер экрана при котором чарт принудительно переносит легенду под чарт
  const windowWidthToWrap = 1590;
  pieWrap.value = window.innerWidth < windowWidthToWrap ? true : false;
};

onMounted(async () => {
  await getData();

  emitter.on("refresh-expenses-dashboard-data", getData);
  setPieWrap();
  window.addEventListener("resize", setPieWrap);
});

onBeforeUnmount(() => {
  emitter.off("refresh-expenses-dashboard-data");
  window.removeEventListener("resize", setPieWrap);
});
</script>

<style lang="scss" scoped>
.pie {
  &__wrapper {
    width: 50%;
  }
}
</style>
